export function countItemHasMissingCost(item) {
  const quantity = Number(item?.quantity);
  if (!Number.isFinite(quantity) || quantity <= 0) return false;
  if (item?.cost_status === "known" || item?.cost_status === "estimated") return false;
  const price = Number(item?.purchase_price);
  if (Number.isFinite(price) && price > 0) return false;
  return true;
}

export function countMissingCostItems(items) {
  return (Array.isArray(items) ? items : []).filter(countItemHasMissingCost);
}

export function costStatusForPurchasePrice(purchasePrice) {
  const price = Number(purchasePrice);
  return Number.isFinite(price) && price > 0 ? "known" : "missing";
}

/**
 * Persist cost_status from the price being saved.
 * Stored "missing" is truthy and must not stick when purchase_price > 0.
 * Keep explicit "estimated"; otherwise derive from price.
 */
export function resolveCostStatusForSave(purchasePrice, existingStatus) {
  if (existingStatus === "estimated") return "estimated";
  return costStatusForPurchasePrice(purchasePrice);
}

export function priceHistoryRows(entry) {
  if (!entry || entry.state !== "ready") return [];
  return Array.isArray(entry.rows) ? entry.rows : [];
}

export function priceHistoryIsReady(entry) {
  return entry?.state === "ready";
}

export function priceHistoryLoadFailed(entry) {
  return entry?.state === "error";
}

/** Pick the price-history row valid on the given date (count date). */
export function purchasePriceFromHistory(histories, onDate) {
  const rows = Array.isArray(histories) ? [...histories] : [];
  if (rows.length === 0) return null;
  const day = onDate ? new Date(onDate) : new Date();
  const dayTime = Number.isNaN(day.getTime()) ? Date.now() : day.getTime();

  const active = rows.find((row) => {
    const from = row.valid_from ? new Date(row.valid_from).getTime() : null;
    const to = row.valid_to ? new Date(row.valid_to).getTime() : null;
    if (from != null && !Number.isNaN(from) && dayTime < from) return false;
    if (to != null && !Number.isNaN(to) && dayTime > to) return false;
    return row.purchase_price != null && row.purchase_price !== "";
  });
  if (active) return Number(active.purchase_price);

  const past = rows
    .filter((row) => row.purchase_price != null && row.purchase_price !== "")
    .map((row) => ({
      ...row,
      fromTime: row.valid_from ? new Date(row.valid_from).getTime() : 0,
    }))
    .filter((row) => !Number.isNaN(row.fromTime) && row.fromTime <= dayTime)
    .sort((a, b) => b.fromTime - a.fromTime);
  return past[0] ? Number(past[0].purchase_price) : null;
}

export function formatPriceHistoryOption(row, formatNumber) {
  const from = row.valid_from ? new Date(row.valid_from).toLocaleDateString("nb-NO") : "—";
  const to = row.valid_to ? new Date(row.valid_to).toLocaleDateString("nb-NO") : "…";
  const price = formatNumber(row.purchase_price || 0);
  return `${from} – ${to}: ${price}`;
}
